import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import AvailabilityManager from "./ManageAvailability";
import UserSchedule from "./ManageSchedule";

export function UserAvailability({ user }) {
  const [userId, setUserId] = useState(null);
  const [activeSection, setActiveSection] = useState("schedule");
  const [scheduleKey, setScheduleKey] = useState(0); // key forces re-mount of Schedule
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setUserId(user._id);
  }, [user]);

  const handleTabSwitch = (section) => {
    setActiveSection(section);
    if (section === "schedule") {
      setScheduleKey((prevKey) => prevKey + 1);
      // FullCalendar only refetches on a prop change, so pulse the flag.
      setRefresh(true);
      setTimeout(() => setRefresh(false), 100);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Nav
        variant="tabs"
        activeKey={activeSection}
        onSelect={handleTabSwitch}
        className="mb-3"
      >
        <Nav.Item>
          <Nav.Link eventKey="schedule">Schedule</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="availability">Availability</Nav.Link>
        </Nav.Item>
      </Nav>

      <div className="flex-grow-1 overflow-auto">
        {activeSection === "schedule" && (
          <UserSchedule key={scheduleKey} userId={userId} refresh={refresh} />
        )}
        {activeSection === "availability" && userId && (
          <AvailabilityManager userId={userId} />
        )}
      </div>
    </div>
  );
}
